<template>
    <div id="overtime-page">
        <!-- HEADER -->
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="$vuetify.lang.t('$vuetify.overtimeRequest.searchByEmployeeName')"
                        solo
                        height="40px"
                        @keyup.enter="getOvertimeRequestsPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchInquiries()"
                        height="40px"
                        color="primary"
                        outlined>
                        {{ $vuetify.lang.t('$vuetify.overtimeRequest.search') }}
                    </v-btn>
                </div>

                <div class="ml-day-inquiry">
                    <v-select
                        @change="getOvertimeRequestsPagination()"
                        v-model="status"
                        item-text="text"
                        item-value="value"
                        :items="statusList"
                        outlined
                        height="40px"
                        background-color="#ffffff">
                    </v-select>
                </div>
            </div>
        </div>
        <!-- END HEADER -->

        <!-- DATATABLE -->
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalData"
                :items="items"
                @click:row="seeDetail"
                :loading="loading">
                <template v-slot:[`item.start_date`]="{ item }">
                    <span
                        class="requestStatusText">
                        {{ item.start_date }}
                    </span>
                </template>
                <template v-slot:[`item.hd_reviewed_date`]="{ item }">
                    <span
                        :class="isPending(item.headDepartmentApprovalStatus)">
                        {{ item.hd_reviewed_date }}
                    </span>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <span
                        :class="isPending(item.status['key'])">
                        {{ item.status['value'] }}
                    </span>
                </template>
            </v-data-table>
        </v-card>
        <!-- END DATATABLE -->

        <!-- PAGINATION -->
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
        <!-- END PAGINATION -->
    </div>
</template>

<script>

export default {
    name: 'overtimeRequest',

    data () {
        return {
            // Filter
            search: '',
            statusItems: [],
            status: null,
            pageCount: 1,
            page: 1,
            options: {},
            items: [],
            totalData: 0,
            loading: false,
            branch: null
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.employeeNo'), value: 'employee_no', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.employeeName'), value: 'fullname', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.requestDate'), value: 'submitted_date', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.group'), value: 'group_name', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.department'), value: 'department_name', width: '10%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.inquiry'), value: 'start_date', width: '19%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.headDepartmentApproval'), value: 'hd_reviewed_date', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.overtimeRequest.status'), value: 'status', width: '12%' }
            ]
        },
        statusList () {
            const status = this.statusItems
            status.unshift({
                text: this.$vuetify.lang.t('$vuetify.overtimeRequest.allStatus'),
                value: null
            })
            return status
        }
    },

    methods: {
        async searchInquiries () {
            this.options.page = 1
            await this.getOvertimeRequestsPagination()
        },

        async getOvertimeRequestsPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            let url = `overtime-requests?branch=${this.branch}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.status) {
                url += `&overtimeRequestStatus=${this.status}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.items = res.data.data
                this.totalData = res.data.total
                this.loading = false
            }
        },

        async getBranch () {
            this.branch = localStorage.getItem('currentBranchId')
            if (this.branch) {
                await this.getOvertimeRequestsPagination()
            }
        },

        async getStatus () {
            const res = await this.axios.get('overtime-request/status')
            if (res && res.data && res.data.status === 'ok') {
                this.statusItems = res.data.data
            }
        },

        isPending (status) {
            let style = ''
            if (status === 'PND') {
                style += 'highlight'
            }

            return style
        },

        seeDetail (item) {
            const id = item.request_no
            if (id) {
                this.$router.push({ name: 'OvertimeRequestForm', params: { id } })
            }
        }
    },

    async mounted () {
        await this.getBranch()
        await this.getStatus()
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getOvertimeRequestsPagination()
                }
            }
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.branch) {
                    await this.getOvertimeRequestsPagination()
                }
                await this.getStatus()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

::v-deep .v-input__prepend-inner {
    margin: auto !important;
}

::v-deep .v-input__append-inner {
    margin-top: 0.75rem !important;
}

::v-deep .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eeeeee;
    cursor: pointer;
}

.ml-day-inquiry {
    margin-left: 40px;
}

.highlight {
    padding: 0rem 1rem;
    background-color: #ff544a;
    border-radius: 25px;
    color: white;
}
.success {
    padding: 0rem 1rem;
    background-color: #5cb85c;
    border-radius: 25px;
    color: white;
}

.requestStatusText {
    text-align: left;
    color: #6c98ba;
}

@media only screen and (max-width: 1650px) {
    .highlight {
        font-size: 14px;
    }
}

@media only screen and (max-width: 1560px) {
    .highlight {
        padding: 0px 12px;
        margin-left: -8px;
        margin-right: -8px;
    }
}
</style>
